var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActiveContractIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7.0916 13.65c0.0832-0.4713 0.2214-0.9236 0.40774-1.35h-4.0243v1.35h3.6166z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m9.5017 9.825c-0.52125 0.3747-0.97996 0.8309-1.3575 1.35h-4.6692v-1.35h6.0267z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m12.475 8.7228v-2.2728c0-0.3-0.15-1.05-1.5-1.05h-2.025c-0.375 0-0.6-0.3-0.6-0.6v-2.1c0-1.275-0.675-1.5-0.975-1.5h-5.925v14.85h5.7024c0.1154 0.502 0.29377 0.9799 0.52636 1.425h-6.8288c-0.375 0-0.675-0.3-0.675-0.675v-16.125c0-0.375 0.3-0.675 0.675-0.675h7.275c0.375 0 0.675 0.15 0.9 0.375 1.575 1.425 3.075 2.925 4.5 4.575 0.225 0.225 0.3 0.6 0.3 0.9v2.9065c-0.2698-0.0371-0.5452-0.05626-0.8251-0.05626-0.1769 0-0.352 0.00765-0.525 0.02264z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m3.475 7.35h6.9v1.35h-6.9v-1.35z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m15.51 12.341-3.4125 3.075-0.8625-0.9c-0.3-0.2625-0.75-0.3-1.0125 0-0.26246 0.2625-0.29996 0.675-0.075 0.9375 1.3125 1.725 1.275 1.6875 1.35 1.7625 0.3375 0.3 0.825 0.2625 1.125-0.0375l3.7125-4.0125c0.225-0.225 0.1875-0.6-0.0375-0.825-0.225-0.1875-0.5625-0.1875-0.7875 0z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveContractIcon2);
export default __webpack_public_path__ + "static/media/activeContractIcon2.ff47ed3ef1f8a3f2e3ee0241ef0cb79b.svg";
export { ForwardRef as ReactComponent };